// Migrado VERBATIM de context/DarkMode/index.js (THEME_CONFIGS["high-contrast"]).
import { sharedComponents } from "./shared";

export default {
  muiMode: "dark",
  scrollbarColor: "#FFD700",
  palette: {
    primary:    { main: "#FFD700" },
    secondary:  { main: "#FFFFFF" },
    background: { default: "#000000", paper: "#0D0D0D" },
    text:       { primary: "#FFFFFF", secondary: "#CCCCCC" },
    divider:    "rgba(255,255,255,0.2)",
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6 },
        notchedOutline: { borderColor: "rgba(255,255,255,0.4)" },
        input: { color: "#FFFFFF", "&::placeholder": { color: "rgba(255,255,255,0.5)", opacity: 1 } },
      },
    },
  },
  custom: {
    chat: { sentBg: "#1A1500", quotedSentBg: "#1A1200", quotedReceivedBg: "#1E1E1E", accent: "#FFD700" },
    chartPalette: ["#FFD700", "#FFFFFF", "#00E5FF", "#76FF03", "#FF5252", "#E040FB"],
    login: { bg: "#000000" },
  },
};
